/**
 * 后台接口api
 * Created by Zed on 2019/8/9.
 */

export default {
	// 登录
	LOGIN: 'login',
	// 第三方登录
	THIRD_LOGIN: 'system/user/single/sign',
	// 自定义logo、背景、名称
	GET_LOGO: 'sysDept/platInfo',
	// 验证码
	VALID_CODE: 'kaptcha',
	// 登出
	LOGOUT: 'logout',
	// 用户信息
	GET_USER_INFO: 'info',
	// 修改密码
	UPDATE_PWD: 'password/update',
	// 登录获取验证码
	VERIFY_CODE: "verifyCode",
	// 注册获取验证码
	REG_VERIFY_CODE: "register/verifyCode",
	// 注册
	REG: "register",
	// 忘记密码获取验证码
	FORGET_VERIFY_CODE: "forgot/verifyCode",
	// 忘记密码
	FORGET: "forgot",
	// 修改账户名
	UPDATE_LOGIN_NAME: "loginName/update",
	// 修改昵称
	UPDATE_USER_NAME: "update",
	// 修改手机号
	UPDATE_PHONE: 'phone/update',

	VALID_LIST: "admin/tag/validlist",

	// 11.1.5 轮询按钮状态  /system/config/lock/
	CONFIG_STATUS: "system/config/lock/",

	// 个人信息
	PROFILE: {
		INFO: "system/user/info"
	},

	// 通用接口
	COMMON: { // 通用接口
		UPLOAD_IMG: "admin/apply/image/save",
		SAVE_LAN: "admin/category/saveLanguage",
		UPLOAD_PROGRESS: "admin/media/customMedia/upload/progress/",
		UPLOAD_ICON: 'sysDept/uploadIcon',
		WARN_ALERT: 'notice/handCount',
		EMERGENCY_ALARMS: 'screen/dashboard/emergencyAlarms', // 全局紧急告警弹窗（SOS+跌倒、待处理、未关闭）
		CLOSE_ALARM: 'screen/dashboard/closeAlarm/', // 关闭紧急告警弹窗（POST，路径参数 id）
		ALARM_POPUP_SETTING: 'screen/dashboard/alarmPopupSetting', // 弹窗告警设置（GET回显 / POST保存）
		LOCATION_FREQUENCY: 'screen/workbench/locationFreq', // 定位更新频率（工作台，GET 回显 / POST 保存，frequency: 1/5/15/30/60）
	},

	PERMISSION: { // 系统管理
		MODULE: { // 模块管理
			LIST: 'system/module/list',
			INSERT: 'system/module/create',
			DETAIL: 'system/module/get/',
			UPDATE: 'system/module/update',
			DELETE: 'system/module/delete/',
		},
		MENU: { // 菜单管理
			LIST: 'system/permission/list',
			INSERT: 'system/permission/create',
			DETAIL: 'system/permission/get/',
			UPDATE: 'system/permission/update',
			DELETE: 'system/permission/delete/',
			// MODULE_LIST: 'system/permission/list/module',
		},
		ROLE: { // 角色管理
			LIST: 'system/role/list',
			INSERT: 'system/role/create',
			DETAIL: 'system/role/get/',
			UPDATE: 'system/role/update',
			DELETE: 'system/role/delete/',
			MENU_LIST: 'system/role/list/permission',
		},
		USER: { // 用户管理
			LIST: 'system/user/list',
			INSERT: 'system/user/create',
			DETAIL: 'system/user/get/',
			UPDATE: 'system/user/update',
			DELETE: 'system/user/delete/',
			ROLE_LIST: 'system/user/list/role',
			OPERATION_LOG_LIST: 'system/user/list/log',
			RESET_PWD: 'system/user/s%/password/reset',
			UPDATE_DEPT: "system/user/update/dept",
			IMITATE_LOGIN: "system/user/imitate/login/s%",
			DEPT_LIST_ALL: 'sysDept/list/all',
		},
		DEPARTMENT: { // 部门管理
			LIST: 'system/dept/list',
			LIST_ALL: 'system/dept/list/all',
			INSERT: 'system/dept/create',
			DETAIL: 'system/dept/get/',
			UPDATE: 'system/dept/update',
			DELETE: 'system/dept/delete/',
			CHANNEL: 'system/dept/list/channel',
			ALL: 'system/dept/tree/',

			BALANCE_LOG: "system/dept/balance/list/log/",

			GET_BALANCE: "system/dept/balance/get/",
			ADD_CONFIG_BALANCE: "system/dept/balance/create",
			UPDATE_BALANCE: "system/dept/balance/update",

			REL_CONFIG_BALANCE: "system/dept/balance/list/relate/config",
			NO_REL_CONFIG_BALANCE: "system/dept/balance/list/select/config",
			ADD_REL_CONFIG_BALANCE: "system/dept/balance/add/relate/config",
			DEL_REL_CONFIG_BALANCE: "system/dept/balance/delete/relate/config",
		},
	},
	SCHEDULE: { //mrs-C调度
		LIST: "server/list",
		DETAIL: "server/get",
	},
	DEVICE: { //设备管理
		LIST: "device/list",
		DETAIL: "device/get",
		INSERT: "device/create",
		UPDATE: "device/update",
		DELETE: "device/delete/{id}",
		ACTIVATE: "device/activate",
	},
	TERMINAL: { // 终端管理
		LIST: "device/list",
		ONLINE_LIST: "device/status",
		ADD: "device/activate",
		RESTART: "device/remote/setSysPower?id=",
		UPDATE_NAME: "device/update",
		DELETE: "device/delete/",
		DETAIL: "device/remote/getSysStatus?id=",
		NET_DETAIL: "device/remote/getNetbindPortStatus?id=",
		AGG_DETAIL: "device/remote/getNetbindBind?id=",
		UPDATE_AGG: "device/remote/setNetbindBind?id=",
		UPGRADE: "device/upgrade?id=",
		CHECK_UPGRADE: "device/upgrade/check",
		LOG: "device/remote/log",
		POSITION: "device/get/",
	},
	LIVE: { // 直播管理
		LIST: "live/list",
		ADD_LIVE: "live/create",
		DETAIL: "live/route/get/",
		DEVICE_LIST: "device/list",
		MEDIA_SERVE: "server/list/all",
		AGG_SERVE: "aggServer/list/all",
		AGG_DELAY: "device/remote/getNetbindDelay?id={id}&liveId={liveId}", // 获取聚合服务器延迟信息
		PUSH_STATUS: "device/remote/getLiveEnabled?id={id}&liveId={liveId}", // 获取推流状态
		UPDATE_PUSH_STATUS: "device/remote/setLiveEnabled?id={id}&liveId={liveId}", // 设置推流状态
		PARAMS_SOURCE: "device/remote/getAvenc?id={id}&liveId={liveId}", // 获取编码输入源状态
		UPDATE_PARAMS_SOURCE: "device/remote/setAvenc?id={id}&liveId={liveId}", // 设置编码输入源状态
		PARAMS: "device/remote/getAvencParam?id={id}&liveId={liveId}", // 获取编码状态
		UPDATE_PARAMS: "device/remote/setAvencParam?id={id}&liveId={liveId}", // 设置编码状态
		IP_INFO: "device/remote/getNetbindWan?id={id}&liveId={liveId}", // 获取ip信息
		UPDATE_IP_INFO: "device/remote/setNetbindWan?id={id}&liveId={liveId}", // 更新ip信息
		WIFI_LIST: "device/remote/getNetbindWifilist?id={id}&liveId={liveId}", // 获取可用的wifi列表
		CONNECT_WIFI_LIST: "device/remote/getNetbindWifijoin?id={id}&liveId={liveId}", // 获取可用的wifi列表
		UPDATE_WIFI: "device/remote/setNetbindWifijoin?id={id}&liveId={liveId}", // 设置已选择的wifi
		AGG_LIST: "device/remote/getNetbindBind?id={id}&liveId={liveId}", // 获取聚合模式
		UPDATE_AGG: "device/remote/setNetbindBind?id={id}&liveId={liveId}", // 设置聚合模式
		UPDATE_AGG_USE: "live/route/update",
		// UPDATE_AGG_USE: "device/remote/setNetbindServer?id=", // 设置要用的聚合服务器
		UPDATE_USE: "live/route/update", // 设置要用的媒体服务器和直播地址
		DOCUMENT: "live/{id}/dvr/list", // 获取录制文件列表
		DEL_DOCUMENT: "stream/dvr/delete/", // 删除录制文件
		CANCEL_LIVE: "live/update", // 注销直播
		DEL_LIVE: "live/delete/", // 删除直播
		BEFORE_DEL: "live/check/", // 删除或注销前判断在推流
	},
	SOURCE: { // 用户资源
		FLOW: { // 流量统计
			LIST: "flow/list",
			DETAIL: "flow/detail/",
		}
	},
	AGGSERVER: { // 聚合服务器
		LIST: "aggServer/list",
		ADD: "aggServer/create",
		UPDATE: "aggServer/update",
		DELETE: "aggServer/delete/",
	},
	CASTER: { // 云导播
		CASTER_INIT: "live/describe?action=", // 导播台初始化必须接口
	},
	MODEL: { // 终端model管理
		LIST: "model/list",
		ADD_MODEL: "model/create",
		UPDATE_MODEL: "model/update",
		DEL_MODEL: "model/delete/",
		LIST_ALL: "model/list/all",
	},
	UPGRADE: { // 终端升级管理
		LIST: "upgrade/list",
		ADD: "upgrade/create",
		DEL: "upgrade/delete/",
		ANALYSIS: "upgrade/analysis/url",
		// UPLOAD: "upgrade/upload",
	},
	LIVE_STREAM: { //直播流管理
		LIST: "stream/list",
		CREATE: "stream/create",
		DETAIL: "stream/get",
		PUBLISH_URL: "stream/{id}/publish/list",
		PULL_URL: "stream/{id}/play/list",
		SWITCH_ON_OFF: "stream/{id}/dvr/{isOnOff}",
		HISTORY: "stream/{id}/publish/log/list",
		DVR_LIST: "stream/{id}/dvr/list",
		DVR_DELETE: "stream/dvr/delete/{dvrId}",
		FORWARD_LIST: "stream/forward/list",
		FORWARD_SAVE: "stream/forward/create",
		FORWARD_DEL: "stream/forward/delete/{id}",
		FORWARD_DETAIL: "stream/forward/get/{id}",
		FORWARD_SWITCH: "stream/forward/{forwardId}/onOff/{isOnOff}",
	},
	FRP_SERVER: { //frp服务器管理
		LIST: "frpServer/list",
		CREATE: "frpServer/create",
		UPDATE: "frpServer/update",
		DETAIL: "frpServer/get",
		FREE_PORT_LIST: "frpServer/{id}/freePort/list",
		OCCUPIED_PORT_LIST: "frpServer/{id}/occupiedPort/list",
	},
	LOG: {
		STREAM_INFO: {
			LIST: "log/console/streamInfo/list"
		},
		DEVICE_STATUS: {
			LIST: "log/console/deviceStatus/list"
		}
	},
	CHANNEL_DEPT: {
		CHANNEL: {
			LIST: 'sysDept/list',
			CREATE: 'sysDept/create',
			UPDATE: 'sysDept/update',
			DELETE: 'sysDept/delete/',
			DEVICEWATCH_LIST: 'deviceWatch/list',
			BATCHBINDDEVICE: 'sysDept/batchBindDevice',
			DEVICEWATCH_DEPTDEVICE: 'deviceWatch/getDeptDeviceList',
		},
		PLAT: {
			PLAT_LIST: 'plat/list',
			PLAT_ADD: 'plat/create',
			PLAT_UPDATE: 'plat/update',
			PLAT_DEL: 'plat/delete/',
			PLAT_DETAIL: 'plat/get/{id}',
			PLAT_IMPORT: 'excel/importPlatDevice',
			PLAT_BIND_OR_NOT: 'plat/bindPlatInfo',
			PLAT_PUSH_OR_NOT: 'plat/onPlatPush',
			PLAT_RELATED_DEVICE: 'deviceWatch/list'
		}
	},
	DEVICE_MANAGE: {
		DEVICE_LIST: {
			LIST: 'deviceWatch/list',
			DEVICE_INFO: 'deviceWatch/get/{id}',
			LIST_ALL: 'deviceWatch/list/all',
			IMPORT_DEVICE: 'excel/importDevice',
			IMPORT_TEMPLATE: 'excel/download',
			DEVICE_BRAND_LIST: 'deviceBrand/list/all',
			DEVICE_CATEGORY_LIST: 'deviceCategory/list/all',
			DEVICE_MODEL_LIST: 'deviceModel/list/all',
			FAMILY_LIST: 'deviceWatch/sosNumbers',
			FAMILY_SET: 'deviceWatch/set/sosNumber',
			HEALTHY_DATA: 'deviceWatch/hearthData',
			TRACK_LIST: 'deviceWatch/track',
			DEVICE_UPDATE: 'deviceWatch/update',
			TRACK_SET_FENCE: 'deviceWatch/set/deviceFence',
			DEVICE_UNBIND: 'sysDept/removeBindDevice',
			RESET: 'deviceWatch/recoverSet',
			USER_DOWN_LIST: 'deviceWatch/rebornInfo/',
			PLAT_LIST_ALL: 'plat/list/all',
      DEVICE_SET_MOUSE_DPI: '/deviceWatch/setMouseDPI'
		},
		DEVICE_BASIC_INFO: {
			DEVICE_BRAND_PAGE: 'deviceBrand/list',
			DEVICE_BRAND_ADD: 'deviceBrand/create',
			DEVICE_BRAND_UPDATE: 'deviceBrand/update',
			DEVICE_BRAND_DELETE: 'deviceBrand/delete/{id}',
			DEVICE_CATEGORY_PAGE: 'deviceCategory/list',
			DEVICE_CATEGORY_ADD: 'deviceCategory/create',
			DEVICE_CATEGORY_UPDATE: 'deviceCategory/update',
			DEVICE_CATEGORY_DELETE: 'deviceCategory/delete/{id}',
			DEVICE_MODEL_PAGE: 'deviceModel/list',
			DEVICE_MODEL_ADD: 'deviceModel/create',
			DEVICE_MODEL_UPDATE: 'deviceModel/update',
			DEVICE_MODEL_DELETE: 'deviceModel/delete/{id}',
			DEVICE_MODEL_UPLOAD_IMG: 'tbMember/uploadHeadImg',
			DEVICE_FUNC_LIST: 'deviceCapacity/list',
			DEVICE_FUNC_LIST_ALL: 'deviceCapacity/list/all',
			DEVICE_FUNC_ADD: 'deviceCapacity/create',
			DEVICE_FUNC_UPDATE: 'deviceCapacity/update',
			DEVICE_FUNC_DELETE: 'deviceCapacity/delete/{id}',
		},
		BLUETOOTH: {
			LIST: 'bluetooth/list',
			CREATE: 'bluetooth/create',
			ACTIVE: 'bluetooth/storage/active',
			AMOUNT: 'bluetooth/bluetoothTotal',
			ADDRESS: 'bluetooth/sysAddress',
			VIRTUAL_MODEL: 'bluetooth/virtual/model'
		},
    MOUSEAUTH: {
			LIST: 'deviceWatch/AIMouse/page',
      ADD: 'deviceWatch/AIMouse/add',
      UPDATE: 'deviceWatch/AIMouse/update',
      DELETE: 'deviceWatch/AIMouse/delete/{id}',
      IMPORT: 'deviceWatch/AIMouse/import'
		}
	},
	USER_MANAGE: {
		LIST: 'tbMember/list',
		LIST_ALL: 'tbMember/list/all',
		UPLOAD_IMG: 'tbMember/uploadHeadImg',
		CREATE: 'tbMember/create',
		UPDATE: 'tbMember/update',
		DELETE: 'tbMember/delete/{id}',
		DETAIL: 'tbMember/get/',
		USER_DEVICE_BIND: 'tbMember/memberDeviceBind',
		USER_DEVICE_UNBIND: 'tbMember/removerDeviceBind',
		USER_IMPORT: 'tbMember/import',
		USER_TEMPLATE: 'tbMemberPush/download',
		USER_SWITCH: 'tbMember/memberNoticeSwitch'
	},
	PUSH_MANAGE: {
		LIST: 'tbMemberPush/list',
		CREATE: 'notice/push/create',
		UPDATE: 'notice/push/update',
		DELETE: 'notice/push/delete',
		DELETE_BATCH: 'notice/push/delete',
		// IMPORT_PUSH: 'tbMemberPush/importMemberPush',
		IMPORT_PUSH: 'notice/push/importNoticePush',
		WARN_LIST: 'notice/list',
		PUSH_LIST: 'notice/push/list',
		WAIT_LIST: 'notice/carousel',
		NOTICE_HANDLE: 'notice/handle',
		NOTICE_HANDLE_BATCH: 'notice/handle/batch'
	},
	// 健康管理
	HEALTHY_DATA: {
		STEP_LIST: 'lek/stepNumber/list', // 步数列表
		HEART_RATE_LIST: 'lek/heart/list', // 心率列表
		BLOOD_PRESSURE_LIST: 'lek/bloodPressure/list', // 血压列表
		BLOOD_OXYGEN_LIST: 'lek/bloodOxygen/list', // 血氧列表
		SLEEP_LIST: 'lek/sleep/list', // 睡眠
		PRESSURE_LIST: 'lek/stress/list', // 压力
		TEMPERATURE_LIST: 'lek/temperature/list', // 温度
		BLOOD_SUGAR_LIST: 'lek/bloodSugar/list', // 血糖
		LOCATION_LIST: 'lek/location/list', // 位置
	},
	// 数据统计
	DATA_STATISTICS: {
		DEVICE_USE: {
			DATA: 'deviceWatch/statistics', // 设备使用情况
		},
		BIG_DATA: {
			BASIS_DATA: 'screen/baseData', // 基础数据
			DEVICE_STATUS_DATA: 'screen/deviceWatchStatus', // 设备状态统计
			BLOOD_OXYGEN_DATA: 'screen/bloodOxygen', // 血氧统计
			BLOOD_SUGAR_DATA: 'screen/bloodSugarData', // 血糖统计
			STANDARD_DATA: 'screen/standardData', //指标异常统计
			HEALTHY_DATA: 'screen/hearthData', // 健康状况分布
			MONITOR_DATA: 'screen/realMonitorData', // 实时监测数据
			DEVICE_DETAIL: 'deviceWatch/getScreenDetail/', // 获取设备详情信息
		}
	},
	// 电子围栏
	ELECTRIC_FENCE: {
		DEPT_LIST: 'electronic/fence/deptList', // 渠道列表
		FENCE_LIST: 'electronic/fence/fenceList/{deptId}', // 围栏列表
		FENCE_STATISTICS_DATA: 'electronic/fence/statistics/{fenceId}', // 围栏统计数据
		FENCE_DATA: 'electronic/fence/device/data/{fenceId}', // 电子围栏详情以及设备点位数据
		FENCE_DEVICE_LIST: 'electronic/fence/device/list/{fenceId}', // 围栏绑定的设备分页列表
		BATCH_UNBIND_FENCE_DEVICE: 'electronic/fence/unbind/batch', // 批量解除电子围栏
		BATCH_BIND_FENCE_DEVICE: 'electronic/fence/bind/batch', // 批量绑定电子围栏
		BATCH_IMPORT_FENCE_DEVICE: 'electronic/fence/excel/import', // 批量导入电子围栏
		ADD_FENCE: 'electronic/fence/create', // 新增电子围栏
		UPDATE_FENCE: 'electronic/fence/update', // 更新电子围栏
		DELETE_FENCE: 'electronic/fence/del/{fenceId}', // 删除电子围栏
	},
	// 首页数据大屏
	HOME: {
		DEVICE_STATS: 'screen/dashboard/deviceStats', // 设备状态统计（总/激活/在线/离线 + 比率）
		ALARM_STATS: 'screen/dashboard/alarmStats', // 告警情况 + 告警分类（今日/已处理/待处理 + 5类）
		TODAY_ALARMS: 'screen/dashboard/todayAlarms', // 当日告警事件列表
		DEVICES: 'screen/dashboard/devices', // 地图设备/告警点位（7类：在线/离线 + 5类告警）
		MAP_CENTER: 'screen/dashboard/mapCenter', // 地图中心点（经纬度 + 5km半径内设备数）
	},
	// 工作台
	WORKBENCH: {
		STAT_CARDS: 'screen/workbench/statCards', // 统计卡片（总设备/激活/在线/离线/今日告警）
		PENDING_ALARMS: 'screen/workbench/pendingAlarms', // 待处理告警列表
	}
};
